import { IconButton, Modal, SingleSelectDropdown, TextInput } from "@carbon6/c6-frontend-design";
import { useId, type ChangeEvent, type ReactNode } from "react";
import { hatcheryDropdownModes } from "@/app/theme";
import { HatModalHeader } from "@/components/modal";
import type { GroupOption } from "./useSharedWorkspaces";
import styles from "./SharedWorkspaceModal.module.css";

// 새 Workspace 를 만들고 바로 공용으로 등록한다. registry 가 만든 workspace 는 alias 가 있어서
// 등록이 실패하지 않는다. 만든 뒤 바로 등록하는 것이 이 모달의 한 동작이다.
export function CreateSharedWorkspaceModal({
  busy,
  groupId,
  groupOptions,
  name,
  onClose,
  onCreate,
  onGroupChange,
  onNameChange,
}: {
  busy: boolean;
  groupId: string | null;
  groupOptions: GroupOption[];
  name: string;
  onClose: () => void;
  onCreate: () => void;
  onGroupChange: (value: string) => void;
  onNameChange: (value: string) => void;
}): ReactNode {
  const titleId = useId();
  return (
    <Modal
      open
      onClose={onClose}
      size="sm"
      level="top"
      closeOnBackdropClick={!busy}
      closeOnEscape={!busy}
      aria-labelledby={titleId}
    >
      <HatModalHeader
        title="새 공용 Workspace 만들기"
        titleId={titleId}
        close={{ disabled: busy }}
      />
      <div className={styles.createBody}>
        <SingleSelectDropdown
          mode={hatcheryDropdownModes.default}
          label="Team"
          value={groupId}
          options={groupOptions}
          placeholder="Team을 선택해 주세요."
          disabled={busy}
          onValueChange={onGroupChange}
        />
        <TextInput
          value={name}
          placeholder="Workspace 이름을 입력해 주세요."
          aria-label="Workspace 이름"
          disabled={busy}
          onChange={(event: ChangeEvent<HTMLInputElement>) => onNameChange(event.target.value)}
        />
      </div>
      {/* 취소와 확정은 푸터에 둔다. 이 앱의 다른 모달과 같은 위치다. */}
      <Modal.Footer>
        <IconButton text="취소" size="sm" variant="surface" disabled={busy} onClick={onClose} />
        <IconButton
          text="만들고 등록"
          size="sm"
          variant="solid"
          disabled={busy || groupId === null || name.trim() === ""}
          onClick={onCreate}
        />
      </Modal.Footer>
    </Modal>
  );
}
